export default [
  {
    name: 'AT&T Plan',
    value: 'att_plan',
  },
  {
    name: 'Credit',
    value: 'credit',
  },
  {
    name: 'Device Protection',
    value: 'insurance_plan',
  },
  {
    name: 'Lease buyout',
    value: 'lease_buyout',
  },
  {
    name: 'Lease down payment',
    value: 'lease_down',
  },
  {
    name: 'Lease payment',
    value: 'lease',
  },
  {
    name: 'Mdn change fee',
    value: 'mdn_change_fee',
  },
  {
    name: 'Product',
    value: 'product',
  },
  {
    name: 'Product down payment',
    value: 'product_down',
  },
  {
    name: 'Quick plan',
    value: 'quick_plan',
  },
  {
    name: 'Shipping',
    value: 'shipping',
  },
  {
    name: 'Simo plan',
    value: 'simo_plan',
  },
  {
    name: 'Split payment',
    value: 'split',
  },
];

export const plansByMobileOperator = {
  att: ['att_plan'],
  simo: ['simo_plan'],
  quick: ['quick_plan'],
  all: [
    'lease',
    'lease_buyout',
    'lease_down',
    'product',
    'product_down',
    'credit',
    'split',
    'insurance_plan',
    'shipping',
  ],
};
